import { Clock3, Maximize2, Minimize2, RefreshCw, Store } from 'lucide-react';

import ActionButton from '../../../../components/Buttons/ActionButton';

interface KitchenStatusBarProps {
  pending: number;
  inPreparation: number;
  ready: number;
  stationScoped: boolean;
  lastUpdatedAt: string | null;
  loading: boolean;
  refreshing: boolean;
  disabled: boolean;
  fullscreen: boolean;
  compact?: boolean;
  onRefresh: () => void;
  onToggleFullscreen: () => void;
}

const KitchenStatusBar = ({
  pending,
  inPreparation,
  ready,
  stationScoped,
  lastUpdatedAt,
  loading,
  refreshing,
  disabled,
  fullscreen,
  compact = false,
  onRefresh,
  onToggleFullscreen,
}: KitchenStatusBarProps) => {
  return (
    <div
      className={`flex flex-col border-b border-stroke bg-gray-2/50 dark:border-strokedark dark:bg-meta-4/30 lg:flex-row lg:items-center lg:justify-between ${
        compact ? 'gap-2 px-4 py-2' : 'gap-4 px-5 py-4 sm:px-7'
      }`}
    >
      {compact ? (
        <div className="flex flex-wrap gap-2 text-xs font-semibold">
          <span className="text-warning">{pending} pend.</span>
          <span className="text-primary">· {inPreparation} preparando</span>
          <span className="text-success">· {ready} listas</span>
        </div>
      ) : (
        <div className="flex flex-wrap gap-3">
          <span className="rounded-lg border border-warning/30 bg-warning/10 px-3 py-2 text-sm font-semibold text-warning">
            {pending} pendientes
          </span>

          <span className="rounded-lg border border-primary/30 bg-primary/10 px-3 py-2 text-sm font-semibold text-primary">
            {inPreparation} preparando
          </span>

          <span className="rounded-lg border border-success/30 bg-success/10 px-3 py-2 text-sm font-semibold text-success">
            {ready} listas
          </span>
        </div>
      )}

      <div className="flex flex-wrap items-center gap-3 text-xs text-bodydark2">
        {stationScoped && !compact && (
          <span className="inline-flex items-center gap-1">
            <Store className="h-3.5 w-3.5" />
            Acciones limitadas a platos de la estación
          </span>
        )}

        {lastUpdatedAt && (
          <span className="inline-flex items-center gap-1">
            <Clock3 className="h-3.5 w-3.5" />
            {new Date(lastUpdatedAt).toLocaleTimeString('es-SV', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
            })}
          </span>
        )}

        <ActionButton
          label={refreshing ? 'Actualizando' : 'Actualizar'}
          icon={
            <RefreshCw
              className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`}
            />
          }
          variant="secondary"
          size="sm"
          fullWidth={false}
          disabled={loading || refreshing || disabled}
          onClick={onRefresh}
        />

        <ActionButton
          label={fullscreen ? 'Salir' : 'Pantalla completa'}
          icon={
            fullscreen ? (
              <Minimize2 className="h-4 w-4" />
            ) : (
              <Maximize2 className="h-4 w-4" />
            )
          }
          variant="secondary"
          size="sm"
          fullWidth={false}
          disabled={disabled}
          onClick={onToggleFullscreen}
        />
      </div>
    </div>
  );
};

export default KitchenStatusBar;
